var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#ED7166"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68555 11.1587V17.5H7.0127V15.5312H8.26514C9.60107 15.5312 10.5283 14.6567 10.5283 13.3516C10.5283 12.0332 9.63623 11.1587 8.33105 11.1587H5.68555ZM7.0127 12.2485H7.97949C8.74414 12.2485 9.1792 12.6353 9.1792 13.356C9.1792 14.0679 8.73535 14.4546 7.9751 14.4546H7.0127V12.2485ZM11.75 11.1543V17.5H14.2461C16.1445 17.5 17.2212 16.3442 17.2212 14.2832C17.2212 12.2969 16.1313 11.1543 14.2461 11.1543H11.75ZM13.0771 12.2881H14.0352C15.1865 12.2881 15.8677 13.022 15.8677 14.3052C15.8677 15.6455 15.2085 16.3662 14.0352 16.3662H13.0771V12.2881ZM19.8008 17.5V15.0303H22.3804V13.9448H19.8008V12.2925H22.6265V11.1587H18.4736V17.5H19.8008Z",
    fill: "#ED7166"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.131e01885f3c9214ce5e8cab29d41c70.svg";
export { ForwardRef as ReactComponent };